import Vue from 'vue';
import Router from 'vue-router';
import crm from './views/crm.vue';
import infcrm from './views/inf-crm.vue';
import Login from './views/Login.vue';
import InstantSearch from 'vue-instantsearch';;
import Help from './views/help';
import whatsapp from './views/whatsapp';
import whatsappChat from './views/whatsappChat';
import whatsappMass from './views/whatsappMass';
import emailsMass from './views/emailsMass';
import emailTemplates from './views/emailTemplates';
import smsMass from './views/smsMass';
import smsTemplates from './views/smsTemplates';
import importData from './views/importData';
import data from './views/data';
import landingPageGenerator from './views/landingPageGenerator';
import shortlink from './views/shortlink';
import shortlinks from './views/shortlinks';
import instagramPost from './views/instagramPost';
import importOrders from './views/importOrders';
import importProducts from './views/importProducts';
import importCity from './views/importCity';
import orders from './views/orders';
import whatsappCampaigns from './views/whatsappCampaigns';
import altDashboard from './views/altDashboard';
import backup from './views/backup';
import campaigns from './views/campaigns';
import old_products from './views/old_products';
import products from './views/products';
import Dashboard from './views/Dashboard';
import newVoucher from './views/newVoucher';
import vouchers from './views/vouchers';
import csvToJson from './views/csvToJson';
import clearance from './views/clearance';
import formEmbeds from './views/formEmbeds';
import formBuilder from './views/formBuilder';
import shippingUpdate from './views/shippingUpdate';
import manualMigrate from './views/manualMigrate';
import warehouse from './views/warehouse';
import warehouseLive from './views/warehouseLive';
import userSettings from './views/userSettings';
import invoiceSettings from './views/invoiceSettings';
import invoicing from './views/invoicing';
import wasetting from './views/wasetting';
import waChatNew from './views/waChatNew';
import warehouseLog from './views/warehouseLog';
import scanner from './views/scanner';
import reverseStatusByKey from './views/reverseStatusByKey';
import Q from './views/Q';
import productsCatalogue from './views/productsCatalogue';
import warehouseIntegration from './views/warehouseIntegration';
import warehouseApp from './views/warehouseApp';
import paymentUpdate from './views/paymentUpdate';
import infInvoicing from './views/infInvoicing';
import infInvoices from './views/infInvoices';
import purchase from './views/purchase';
import purchaseOrders from './views/purchaseOrders';
import poHurtOrders from './views/poHurtOrders';
import poMoveOrders from './views/poMoveOrders';
import callCenterJobsSetup from './views/callCenterJobsSetup';
import landingPages from './views/landingPages';
import staticPages from './views/staticPages';
import purchaseMove from './views/purchaseMove';
import statsDB from './views/statsDB';
import manualWASender from './views/manualWASender';
import bulkVendorPricing from './views/bulkVendorPricing';
import bulkSkuRemaining from './views/bulkSkuRemaining';
import poPriceHistory from './views/poPriceHistory';
import csvKeyToArchive from './views/csvKeyToArchive';
import logsSync from './views/logsSync';
import dataLogs from './views/dataLogs';
import reservationSettings from './views/reservationSettings';
import reservationShippingCities from './views/reservationShippingCities';



Vue.use(Router);
Vue.use(InstantSearch);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/crm',
      name: 'crm',
      component: crm
    },
    {
      path: '/logs-sync',
      name: 'logs-sync',
      component: logsSync
    },
    {
      path: '/data-logs',
      name: 'data-logs',
      component: dataLogs
    },
    {
      path: '/inf-crm',
      name: 'inf-crm',
      component: infcrm
    },
    {
      path: '/bulk-vendor',
      name: 'bulk-vendor',
      component: bulkVendorPricing
    },
    {
      path: '/bulk-remaining',
      name: 'bulk-remaining',
      component: bulkSkuRemaining
    },
    {
      path: '/Q',
      name: 'Q',
      component: Q
    },
    {
      path: '/manual-wa',
      name: 'manualWASender',
      component: manualWASender
    },
    {
      path: '/reservation-settings',
      name: 'reservationSettings',
      component: reservationSettings
    },
    {
      path: '/reverse-by-key',
      name: 'reverseStatusByKey',
      component: reverseStatusByKey
    },
    {
      path: '/call-center-setup',
      name: 'callCenterSetup',
      component: callCenterJobsSetup
    },
    {
      path: '/user-settings',
      name: 'userSettings',
      component: userSettings
    },
    {
      path: '/invoice-settings',
      name: 'invoiceSettings',
      component: invoiceSettings
    },
    {
      path: '/invoicing',
      name: 'invoicing',
      component: invoicing
    },
    {
      path: '/warehouse',
      name: 'warehouse',
      component: warehouse
    },
    {
      path: '/warehouse-app',
      name: 'warehouseApp',
      component: warehouseApp
    },
    {
      path: '/warehouse-live',
      name: 'warehouseLive',
      component: warehouseLive
    },
    {
      path: '/warehouse-log',
      name: 'warehouseLog',
      component: warehouseLog
    },
    {
      path: '/scanner',
      name: 'scanner',
      component: scanner
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: campaigns
    },
    {
      path: '/old_products',
      name: 'old_products',
      component: old_products
    },
    {
      path: '/products',
      name: 'products',
      component: products
    },
    {
      path: '/landing-pages',
      name: 'landing-pages',
      component: landingPages
    },
    {
      path: '/static-pages',
      name: 'static-pages',
      component: staticPages
    },
    {
      path: '/new-voucher/:token?',
      name: 'newVoucher',
      component:newVoucher
    },
    {
      path: '/vouchers',
      name: 'vouchers',
      component:vouchers
    },
    {
      path: '/orders/:id',
      name: 'orders',
      component: orders
    },
    {
      path: '/backup',
      name: 'backup',
      component:backup
    },
    {
      path: '/delete-by-key',
      name: 'csvToJson',
      component:csvToJson
    },
    { 
      path: '/import-orders',
      name: 'import-orders',
      component:importOrders
    },
    { 
      path: '/import-products',
      name: 'import-products',
      component:importProducts
    },
    { 
      path: '/import-cities',
      name: 'import-cities',
      component:importCity
    },
    {
      path: '/whatsapp',
      name: 'whatsapp',
      component: whatsapp
    },
    {
      path: '/wa-chat',
      name: 'whatsappChat',
      component: whatsappChat
    },
    {
      path: '/wa-chat/n/:number?',
      name: 'whatsappChatN',
      component: whatsappChat
    },
    {
      path: '/wa-mass',
      name: 'whatsappMass',
      component: whatsappMass
    },
    {
      path: '/wa-campaigns',
      name: 'whatsappCampaigns',
      component:whatsappCampaigns
    },
    {
      path: '/email-templates',
      name: 'emailTemplates',
      component: emailTemplates
    },
    {
      path: '/email-mass',
      name: 'emailsMass',
      component: emailsMass
    },
    {
      path: '/sms-mass',
      name: 'smsMass',
      component:smsMass
    },
    {
      path: '/sms-templates',
      name: 'smsTemplates',
      component:smsTemplates
    },
    {
      path: '/clearance-site',
      name: 'clearance',
      component: clearance
    },
    {
      path: '/import-data',
      name: 'importData',
      component: importData
    },
    {
      path: '/data',
      name: 'data',
      component: data
    },
    {
      path: '/shipping',
      name: 'shipping',
      component: shippingUpdate
    },
    {
      path: '/payments',
      name: 'payments',
      component: paymentUpdate
    },
    {
      path: '/migrate',
      name: 'migrate',
      component: manualMigrate
    },
    {
      path: '/landing-page-generator',
      name: 'landing-page-generator',
      component:landingPageGenerator
    },
    {
      path: '/shortlink',
      name: 'shortlink',
      component: shortlink
    },
    {
      path: '/shortlinks',
      name: 'shortlinks',
      component: shortlinks
    },
    {
      path: '/instagram-post',
      name: 'instagramPost',
      component: instagramPost
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/form-builder/:id?',
      name: 'form-builder',
      component: formBuilder
    }, {
      path: '/form-embeds/:page?',
      name: 'form-embeds',
      component: formEmbeds
    },
    {
      path: '/issue-invoice/:id?',
      name: 'issue-invoice',
      component: infInvoicing
    }, 
    {
      path: '/inf-invoices/:page?',
      name: 'inf-invoices',
      component: infInvoices
    },
    {
      path: '/purchase/:id?',
      name: 'purchase',
      component: purchase
    }, 
    {
      path: '/move/:id?',
      name: 'move',
      component: purchaseMove
    }, 
    {
      path: '/purchase-orders/:page?',
      name: 'purchase-orders',
      component: purchaseOrders
    },
    {
      path: '/hurt-orders/:page?',
      name: 'hurt-orders',
      component: poHurtOrders
    },
    {
      path: '/move-orders/:page?',
      name: 'move-orders',
      component: poMoveOrders
    },
    {
      path: '/wa-settings',
      name: 'wa-settings',
      component: wasetting
    }, 
    {
      path: '/wa-new-chat',
      name: 'waChatNew',
      component: waChatNew
    },
    {
      path: '/wa-new-chat/n/:number?',
      name: 'waChatNewN',
      component: waChatNew
    },
    {
      path: '/products-catalogue',
      name: 'productsCatalogue',
      component: productsCatalogue
    },
    {
      path: '/warehouse-integration',
      name: 'warehouseIntegration',
      component: warehouseIntegration
    },
    {
      path: '/stats',
      name: 'stats',
      component: statsDB
    },
    {
      path: '/price-history',
      name: 'priceHistory',
      component: poPriceHistory
    },
    {
      path: '/ar-mo',
      name: 'csvKeyToArchive',
      component: csvKeyToArchive
    },
    {
      path: '/shipping-companies-cities',
      name: 'reservationShippingCities',
      component: reservationShippingCities
    },
  ]
})
